/* eslint-disable @typescript-eslint/member-ordering */

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { MatCard } from '@angular/material/card';
import { Router } from '@angular/router';
import { ExpanderContentComponent, IconButtonComponent } from '@libs/common/components';
import { ProductBundleItemModel, ProductModel, ShopProductListItemBaseModel } from '@libs/shop/models';
import { ConfigurableBundleOrderCardFooterComponent } from './configurable-bundle-order-card-footer';
import { ConfigurableBundleOrderCardItemComponent } from './configurable-bundle-order-card-item';

@Component({
  selector: 'ui-configurable-bundle-order-card',
  imports: [
    MatCard,
    ConfigurableBundleOrderCardItemComponent,
    ExpanderContentComponent,
    ConfigurableBundleOrderCardFooterComponent,
    IconButtonComponent,
  ],
  templateUrl: 'configurable-bundle-order-card.component.html',
  styleUrl: 'configurable-bundle-order-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleOrderCardComponent {
  private readonly router: Router = inject(Router);

  public cartItem: InputSignal<ShopProductListItemBaseModel> = input.required();
  public readonly: InputSignal<boolean> = input(false);
  public isRemoveLoading: InputSignal<boolean> = input(false);

  public product: Signal<ProductModel> = computed(() => this.cartItem().productData);
  public bundledProducts: Signal<ProductBundleItemModel[]> = computed(() => this.product().bundle?.products?.filter(x => x.slotType !== 'free') ?? []);
  public bundledFreeProducts: Signal<ProductBundleItemModel[]> = computed(() => this.product().bundle?.products?.filter(x => x.slotType === 'free') ?? []);

  public expanded: WritableSignal<boolean> = signal(true);

  public remove: OutputEmitterRef<void> = output();

  public edit(): Promise<boolean> {
    return this.router.navigate(['/configurable-bundles', this.cartItem().configuredBundleTemplateId]);
  }
}
